import PieChartViz from '../vizs/PieChartViz'
import BaseComponent from './BaseComponent'
/**
 * # {componentLabel} (`class {componentClassName}`)
 * 
 * A pie chart is a circular statistical graphic, which is divided into slices to illustrate numerical proportion. In a pie chart, the arc length of each slice is proportional to the quantity it represents.
 * 
 * ### Example Usage
 * ```javascript
 * 
 *   import {DonutChart} from 'sdv-lib'
 *   
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new DonutChart($el, data, config);
 * ```
 * 
 * This class is only intended to draw simple Pie charts. For regular [Donut Chart](#/developer/DonutChartComponent)s see the corresponding documentation.
 * 
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 2 columns. Each row represents a sector: the first column should be the id/label of the sector, and the second column its value.
 *  
 * | category | value  |
 * | -------- | ------ |
 * |   a      |    22.4|
 * |   b      |    52.3|
 * |   c      |    12.8|
 * |   d      |    26.0|
 * 
 * {.data-table}
 * */
export default class PieChartComponent extends BaseComponent {
  static vizClass = PieChartViz
  static componentLabel = "Pie chart"
  static dataFormat = [
    {index:0, axis:'', types:[String], role:'id', roleLabel:'Category'},
    {index:1, axis:'', types:[Number], role:'value', roleLabel:'Value'}
  ]
  static defaultConfig = {
    title: this.componentLabel,
    mode: 'pie',
    centerValue:{
      nonEditable: true
    },
    centerTopText:{
      nonEditable: true
    },
    centerBottomText:{
      nonEditable: true
    },
    
    donutThickness:{
      nonEditable: true
    }
  }
}